import React from "react";
import { Pagination } from "antd";

/**
 * تذييل موحّد لجداول اللوحة: ملخّص نصي عن نطاق الأسطر المعروضة
 * ("عرض 21 – 30 من أصل 37") إلى جانب أزرار التنقّل بين الصفحات.
 *
 * @param {number} current رقم الصفحة الحالية (يبدأ من 1)
 * @param {number} pageSize عدد الأسطر في الصفحة (per_page من الخادم)
 * @param {number} total إجمالي الأسطر في الجدول كله (meta.total)
 * @param {number} [rangeFrom] رقم أول سطر — يُفضّل meta.from من الخادم
 * @param {number} [rangeTo] رقم آخر سطر — يُفضّل meta.to من الخادم
 * @param {(page: number) => void} onChange
 * @param {string} [itemLabel] وحدة العد في النص ("موظف"، "حجز"...)
 */
const TablePagination = ({
  current,
  pageSize,
  total,
  rangeFrom,
  rangeTo,
  onChange,
  loading = false,
  itemLabel = "سجل",
}) => {
  // نعتمد قيم الخادم إن توفّرت، وإلا نحسبها — فليست كل الـ endpoints ترجّع from/to
  const from = rangeFrom ?? (total ? (current - 1) * pageSize + 1 : 0);
  const to = rangeTo ?? Math.min(current * pageSize, total);
  const pageCount = Math.ceil(total / pageSize) || 1;

  return (
    <div className="table-footer">
      <div className="table-footer__summary" aria-live="polite">
        {total > 0 ? (
          <>
            عرض <strong>{from}</strong> – <strong>{to}</strong> من أصل{" "}
            <strong>{total}</strong> {itemLabel}{" "}
            {pageCount > 1 && (
              <span className="table-footer__page">
                (صفحة {current} من {pageCount})
              </span>
            )}
          </>
        ) : (
          !loading && <>لا توجد سجلات</>
        )}
      </div>

      {total > pageSize && (
        <Pagination
          className="table-pagination"
          current={current}
          pageSize={pageSize}
          total={total}
          showSizeChanger={false}
          onChange={onChange}
        />
      )}
    </div>
  );
};

export default TablePagination;
